// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__kUe88","avatarProfile":"menu_avatarProfile__2w9fc","navbarbrand":"menu_navbarbrand__2wNSk"};